// Shared chart look: bolder labels, thicker lines, rounded bars and value labels on bars.
// Defaults only — a chart's own options still win. Installed once in main.js.

export const FONT = 'Inter, Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

export const PALETTE = [
  '#2563eb', '#059669', '#f59e0b', '#dc2626', '#7c3aed',
  '#0891b2', '#db2777', '#65a30d', '#ea580c', '#4f46e5',
];

const label = { color: '#334155', fontSize: '12.5px', fontWeight: '600' };

export function installChartTheme(Highcharts) {
  Highcharts.setOptions({
    colors: PALETTE,
    chart: { style: { fontFamily: FONT } },
    title: { style: { color: '#0f172a', fontSize: '17px', fontWeight: '800' } },
    subtitle: { style: { color: '#475569', fontSize: '13px', fontWeight: '500' } },
    xAxis: {
      labels: { style: label },
      title: { style: { color: '#475569', fontWeight: '700' } },
      lineColor: '#cbd5e1',
      tickColor: '#cbd5e1',
    },
    yAxis: {
      labels: { style: label },
      title: { style: { color: '#475569', fontWeight: '700' } },
      gridLineColor: '#eef2f7',
    },
    legend: {
      itemStyle: { color: '#1e293b', fontSize: '13px', fontWeight: '700' },
      itemHoverStyle: { color: '#2563eb' },
    },
    tooltip: {
      borderRadius: 10,
      borderWidth: 0,
      shadow: true,
      style: { fontSize: '13px' },
    },
    plotOptions: {
      series: {
        dataLabels: { style: { fontSize: '12px', fontWeight: '800', textOutline: 'none' } },
      },
      line: { lineWidth: 3.5, marker: { radius: 5, lineWidth: 2, lineColor: '#fff' } },
      spline: { lineWidth: 3.5, marker: { radius: 5, lineWidth: 2, lineColor: '#fff' } },
      area: { lineWidth: 3.5, fillOpacity: 0.25 },
      areaspline: { lineWidth: 3.5, fillOpacity: 0.25 },
      column: {
        borderRadius: 6, borderWidth: 0, pointPadding: 0.06, groupPadding: 0.12,
        dataLabels: { enabled: true, color: '#0f172a' },
      },
      bar: {
        borderRadius: 6, borderWidth: 0, pointPadding: 0.06, groupPadding: 0.12,
        dataLabels: { enabled: true, color: '#0f172a' },
      },
      pie: {
        borderWidth: 3,
        borderColor: '#fff',
        dataLabels: { style: { fontSize: '13px', fontWeight: '700', color: '#0f172a' } },
      },
    },
  });
}

// ApexCharts reads global defaults from window.Apex.
export function installApexTheme() {
  // No label colours here: dark charts set chart.foreColor, which explicit colours would override.
  const axisLabels = { style: { fontSize: '12.5px', fontWeight: 600 } };
  window.Apex = {
    chart: { fontFamily: FONT },
    colors: PALETTE,
    dataLabels: { style: { fontSize: '12px', fontWeight: 800 } },
    xaxis: { labels: axisLabels },
    yaxis: { labels: axisLabels },
    legend: { fontSize: '13px', fontWeight: 700 },
    plotOptions: { bar: { borderRadius: 6 } },
    grid: { borderColor: '#eef2f7' },
  };
}
